export default function LocationValue(props) {
    const {value} = props;

    if (!value || !value?.title || !value?.link) return <></>

    return <a href={value.link} target='_blank'>{value.title || value.link}</a>
}

